import { render, staticRenderFns } from "./TermsAndPrivacy.vue?vue&type=template&id=b00fa994&scoped=true&"
import script from "./TermsAndPrivacy.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00fa994",
  null
  
)

export default component.exports